/* eslint-disable no-empty,@typescript-eslint/no-unused-vars,radix */

xplenty.directive('bigQueryDestinationEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./big-query-destination-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        function ($scope) {
          $scope.onRecordsChange = (records) => {
            $scope.component.column_mappings = records;
          };

          if (typeof $scope.component.max_bad_records === 'string') {
            try {
              $scope.component.max_bad_records = parseInt($scope.component.max_bad_records);
            } catch (e) {}
          }
        },
      ],
    };
  },
]);
